module.exports = __webpack_public_path__ + "static/media/pdf-gris.5cb1cf6c.svg";